export default __webpack_public_path__ + "static/media/courses-at-school-location-icon.c449961c.png";